import React from 'react';
import { Chip, Stack } from '@mui/material';
import { Box } from '@mui/system';
import { ChannelFilterValues } from './channelFilters';

const POSTED_WITHIN_DAYS = 30;

interface ChannelFiltersToolbarProps {
  value: ChannelFilterValues;
  onChange: (value: ChannelFilterValues) => void;
}

export function ChannelFiltersToolbar({ value, onChange }: ChannelFiltersToolbarProps) {
  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1, minHeight: 34, width: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'nowrap',
          overflowX: 'auto',
          gap: 1,
          flex: 1,
          minWidth: 0,
          py: 0.5,
          scrollbarWidth: 'thin',
          '&::-webkit-scrollbar': { height: 6 },
        }}
      >
        <Chip
          label="Has email"
          clickable
          color={value.hasEmail ? 'primary' : 'default'}
          variant={value.hasEmail ? 'filled' : 'outlined'}
          onClick={() => onChange({ ...value, hasEmail: !value.hasEmail })}
          sx={{ flexShrink: 0 }}
        />
        <Chip
          label="Has social"
          clickable
          color={value.hasSocial ? 'primary' : 'default'}
          variant={value.hasSocial ? 'filled' : 'outlined'}
          onClick={() => onChange({ ...value, hasSocial: !value.hasSocial })}
          sx={{ flexShrink: 0 }}
        />
        <Chip
          label={`Posted in last ${POSTED_WITHIN_DAYS} days`}
          clickable
          color={value.postedWithinDays === POSTED_WITHIN_DAYS ? 'primary' : 'default'}
          variant={value.postedWithinDays === POSTED_WITHIN_DAYS ? 'filled' : 'outlined'}
          onClick={() => onChange({
            ...value,
            postedWithinDays: value.postedWithinDays === POSTED_WITHIN_DAYS ? null : POSTED_WITHIN_DAYS,
          })}
          sx={{ flexShrink: 0 }}
        />
      </Box>
    </Stack>
  );
}
